export const GET_CURRENT_CHURCH = "GET_CURRENT_CHURCH";
export const GET_CURRENT_CHURCH_SUCCESS = "GET_CURRENT_CHURCH_SUCCESS";
export const GET_CURRENT_CHURCH_FAILURE = "GET_CURRENT_CHURCH_FAILURE";
